export function isValidPoint(point){if(!point||typeof point!=='object'){return false;}const{lat,lng}=point;return Number.isFinite(lat)&&Number.isFinite(lng);}